import { useState } from 'react';
import integration from '@sport/integration';
import { useLanguageService } from '../../translations';
import { SettingsButton } from './SettingsButton';

import styles from './Settings.module.scss';

const layouts = [
  // {
  //   name: 'layout-default',
  //   alias: 'Default',
  // },
  // {
  //   name: 'layout-operator-stub',
  //   alias: 'Operator stub',
  // },
  // {
  //   name: 'layout-light',
  //   alias: 'Light',
  // },
  // {
  //   name: 'layout-old-school',
  //   alias: 'Old school ',
  // },
  // {
  //   name: 'layout-simple',
  //   alias: 'Simple',
  // },
]

export const themes = [
  // {
  //   name: 'dark',
  //   alias: 'Dark',
  // },
  // {
  //   name: 'light',
  //   alias: 'Light',
  // },
  {
    name: 'brand2',
    mode: 'dark',
  },
  {
    name: 'brand176',
    mode: 'dark',
  },
  {
    name: 'brand179',
    mode: 'light',
  },
  {
    name: 'brand177',
    mode: 'light',
  },
  {
    name: 'brand183',
    mode: 'dark',
  },
  {
    name: 'brand181',
    mode: 'dark',
  },
];

export const Settings = ({ updateLang, updateTheme }) => {
  const {
    helpers: { emitTheme },
  } = integration;
  const { t, lang, languages } = useLanguageService();
  const [layout, setLayout] = useState(localStorage.getItem('prefers-layout') || 'layout-default');
  const [language, setLanguage] = useState(lang);
  const [activeTheme, setActiveTheme] = useState(localStorage.getItem('prefers-color-theme'));

  const onLangClick = (lang) => {
    setLanguage(lang);
    updateLang(lang);
  }
  const onThemeClick = ({ name, mode }) => {
    localStorage.setItem('prefers-color-theme', name);
    setActiveTheme(name);
    updateTheme(name);
    emitTheme({ name, mode });
    document.body.setAttribute('data-theme-name', name);
  }
  const onLayoutClick = (name) => {
    localStorage.setItem('prefers-layout', name);
    setLayout(name);
  }

  return (
    <div className={styles.container}>
      {layouts.length > 0 && (
        <>
          <h3 className={styles.title}>{t('Layout')}</h3>
          <div className={styles.row}>
            {layouts.map(({name, alias}, i) => (
              <SettingsButton
                key={i}
                activeItem={name === layout}
                name={name}
                alias={alias}
                type={'big'}
                action={() => onLayoutClick(name)}
              />
            ))}
          </div>
        </>
      )}
      <h3 className={styles.title}>{t('Color theme')}</h3>
      <div className={styles.row}>
        {themes.map(({name, mode, alias}, i) => (
          <SettingsButton
            key={i}
            activeItem={name === activeTheme}
            name={name}
            alias={alias}
            type={'no-label'}
            action={() => onThemeClick({name, mode, alias})}
          />
        ))}
      </div>
      <h3 className={styles.title}>{t('Languages')}</h3>
      <div className={styles.row}>
        {languages.map(({name, alias}, i) => (
          <SettingsButton
            key={i}
            activeItem={name === language}
            name={name}
            alias={alias}
            action={() => onLangClick(name)}
          />
        ))}
      </div>
    </div>
  );
}

export default Settings;